import { DayHeading, DaySection } from "./day";

/** The app's topic-world motifs (mobile/src/components/course_world.tsx): nature, workshop, body. */
const MOTIFS = [
  '<path d="M12 21V11M12 13C7 13 4 10 4 5c5 0 8 3 8 8zM12 11c0-5 3-8 8-8 0 5-3 8-8 8z" fill="#fff" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/>',
  '<circle cx="12" cy="12" r="5" fill="none" stroke="#fff" stroke-width="3"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 8l3-3" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>',
  '<path d="M12 20s-8-5-8-11a4.5 4.5 0 0 1 8-2.5A4.5 4.5 0 0 1 20 9c0 6-8 11-8 11z" fill="#fff"/>',
];

/** The ICP: builders at the frontier and professionals in training (docs/spec.md). */
const PEOPLE = [
  {
    star: "#2FA36B",
    who: "Building a fungal computer",
    kind: "Builder at the frontier",
    asked: "“Circuit boards, capacitors, ADCs”",
    got: "Electronics taught only as far as mycelium needs it, then this year’s results on fungal memory, ending at what nobody has solved yet.",
  },
  {
    star: "#6B4EFF",
    who: "Learning robot policies",
    kind: "Builder at the frontier",
    asked: "“How do robots learn to grab things?”",
    got: "From imitation learning to the latest grasping results, each labelled proven or promising, framed around training a policy on a real arm.",
  },
  {
    star: "#E8833A",
    who: "Training as a counsellor",
    kind: "Professional in training",
    asked: "“I’m training as a counsellor”",
    got: "Ethics, consent and confidentiality from her regulator’s own code for her province, with a citation on every key claim.",
  },
];

export function Audience() {
  return (
    <DaySection id="who" label="Who it's for" tone="tint">
      <DayHeading
        center
        eyebrow="Who it’s for"
        title="For people learning toward something."
        intro="Switching careers, training for a profession, building a side project. If you have somewhere to get to, it teaches you the way there, and skips what you don’t need."
      />
      <ul className="mt-14 grid gap-5 md:grid-cols-3">
        {PEOPLE.map((p, i) => (
          <li key={p.who} className="relative rounded-[22px] border-2 border-b-[6px] border-[#E7E3F0] bg-white p-6">
            <span className="grid size-12 place-items-center rounded-full border-b-[4px] border-black/15" style={{ background: p.star }} aria-hidden>
              <svg viewBox="0 0 24 24" className="size-6" dangerouslySetInnerHTML={{ __html: MOTIFS[i]! }} />
            </span>
            <p className="mt-4 text-[11px] font-black tracking-[0.1em] text-[#6B4EFF] uppercase">{p.kind}</p>
            <h3 className="mt-1 text-xl font-black text-[#1C1A27]">{p.who}</h3>
            <p className="mt-4 text-sm font-extrabold text-[#8A8698]">They said</p>
            <p className="mt-1 rounded-2xl border-2 border-b-[4px] border-[#E7E3F0] bg-[#F7F5FF] px-3 py-2 font-extrabold text-[#1C1A27]">{p.asked}</p>
            <p className="mt-4 text-sm font-extrabold text-[#8A8698]">What they got</p>
            <p className="mt-1 leading-relaxed text-[#6B6780]">{p.got}</p>
          </li>
        ))}
      </ul>
      <p className="mx-auto mt-8 max-w-xl text-center text-[15px] leading-relaxed text-[#6B6780]">
        Just curious? Ask why the sky is blue and get the answer straight away.
      </p>
    </DaySection>
  );
}
